import ApiService from './_api.service'
import Filter from '@/models/assortmentfilter.model'
import Curve from '@/models/assortment.model'

const API_ASSORTMENT_URL = '/v1/assortment/'

const AssortmentService = {
    // ASSORTMENT

    read: async function(args) {
        let url = API_ASSORTMENT_URL + '?'
        Object.keys(args).forEach(key => {
            if (args[key] != null) url += key + '=' + args[key] + '&'
        })
        return await ApiService.get(url)
    },
    readHistogram: async function(args) {
        let url = API_ASSORTMENT_URL + 'histogram/?'
        Object.keys(args).forEach(key => {
            if (args[key] != null) url += key + '=' + args[key] + '&'
        })
        return await ApiService.get(url)
    },
    readDetails: async function(args) {
        let url = API_ASSORTMENT_URL + 'details/?'
        Object.keys(args).forEach(key => {
            if (args[key] != null) url += key + '=' + args[key] + '&'
        })
        return await ApiService.get(url)
    },

    // FILTERS
    createFilter: function(entity) {
        let data = new FormData()
        Object.keys(Filter.editableFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.post(API_ASSORTMENT_URL + 'filters/', data)
    },

    readFilters: function(args) {
        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (key == 'parent' && args[key] == null) return
                    queryParams += key + '=' + args[key] + '&'
                })
        }
        return ApiService.get(API_ASSORTMENT_URL + 'filters/' + queryParams)
    },

    updateFilter: async function(id, entity) {
        let data = new FormData()
        Object.keys(Filter.editableFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.patch(
            API_ASSORTMENT_URL + 'filters/' + id + '/',
            data
        )
    },

    deleteFilter: async function(id) {
        return ApiService.delete(API_ASSORTMENT_URL + 'filters/' + id + '/')
    },

    likeFilter: async function(id) {
        return ApiService.patch(
            API_ASSORTMENT_URL + 'filters/' + id + '/like/',
            null
        )
    },

    unlikeFilter: async function(id) {
        return ApiService.patch(
            API_ASSORTMENT_URL + 'filters/' + id + '/unlike/',
            {}
        )
    },

    updateLastSeen: async function(id) {
        return ApiService.patch(
            API_ASSORTMENT_URL + 'filters/' + id + '/update_last_seen/',
            {}
        )
    },

    downloadFile: async function(args) {
        let url = API_ASSORTMENT_URL + 'export/?'
        Object.keys(args).forEach(key => {
            if (args[key] != null) url += key + '=' + args[key] + '&'
        })
        return ApiService.customRequest({
            url,
            method: 'POST',
            responseType: 'blob'
        })
    }
}

export default AssortmentService
export { AssortmentService }
